module.exports = __webpack_public_path__ + "img/DE.707e911e.png";